export default "/bitrix/js/landing/ui/panel/formsettingspanel/content/agreements/dist/images/message-icon.svg"